/**
 * Appends a formatted time to a locale-formatted date string.
 * @param {Date } date The Date object for the login.
 * @param {string } localeFormattedDate Locale formatted date string (e.g., '1/23/2023')
 * @param {object} [i18n={}]  i18n configuration object containing locale and timezone for formatting
 * @param {string} [i18n.locale] The locale to use for time formatting.
 * @param {string} [i18n.timezone] The timezone to use for time formatting.
 * @returns {string} The combined formatted date and time string (e.g., "1/23/2023 10:00 AM"), or empty string if parameters are falsy.
 */
export default function appendFormattedTime(date, localeFormattedDate, i18n = {}) {
    if (!date || !localeFormattedDate || !i18n || !i18n.locale || !i18n.timezone) {
        return '';
    }

    const timeFormatter = new Intl.DateTimeFormat(i18n.locale, {
        hour: 'numeric',
        minute: 'numeric',
        timeZone: i18n.timezone,
    });

    const formattedTime = timeFormatter.format(date);

    return `${localeFormattedDate} ${formattedTime}`;
}
